module.exports = __webpack_public_path__ + "static/media/George C. Wallace - 1968.2c20d5c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/George C. Wallace - 1968.jpg
// module id = 469
// module chunks = 0